import { parseApiUrl, storeMixin, storeGenerator, handleError } from '@/storeMixin'
import { merge } from 'lodash'
import { axiosThux } from '@/axiosThux'

const task = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/task/{profile}/visible-task',
    app: 'task',
    pk: 'id'
  },
  actions: {
    async markDone ({ state, commit, dispatch }, { id }) {
      const url = `${parseApiUrl(this, state.apiUrl)}/${id}/mark-done/`
      return axiosThux.patch(url)
        .then(response => {
          commit('setDetail', response.data)
          commit('refreshList', response.data)
          dispatch('notifySuccess', { title: '', text: this._vm.$t('Task marked as done') }, { root: true })
          return response.data
        })
        .catch(error => {
          handleError(commit, dispatch, error)
          throw error
        })
    },
    async terminateAndBill ({ state, commit, dispatch }, { id, payload }) {
      const url = `${parseApiUrl(this, state.apiUrl)}/${id}/mark-done/`
      return axiosThux.patch(url, { installment: payload })
        .then(response => {
          commit('setDetail', response.data)
          commit('refreshList', response.data)
          dispatch('notifySuccess', { title: '', text: this._vm.$t('Task terminated and installment created') }, { root: true })
          return { task: response.data, installment: response.data.installment }
        })
        .catch(error => {
          handleError(commit, dispatch, error)
          throw error
        })
    },
    async getOpenSubtaskList ({ state, commit, dispatch }, { parent }) {
      // status=1: le sotto-attività cancellate (soft-delete) non bloccano più la
      // chiusura del padre, quindi non vanno elencate tra quelle da chiudere.
      const url = `${parseApiUrl(this, state.apiUrl)}/?page=1&page_size=1000&parent=${parent}&status=1&filter__state__is_final=False`
      return axiosThux.get(url)
        .then(response => {
          return (response.data && response.data.results) || []
        })
        .catch(error => {
          handleError(commit, dispatch, error)
          throw error
        })
    }
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'task', model: 'task' }
    ),
    {
      GENERIC: {
        task: {
          task: {
            DETAIL: {
              ACTIONS: {
                markDone: 'GENERIC/task/task/markDone',
                terminateAndBill: 'GENERIC/task/task/terminateAndBill',
                getOpenSubtaskList: 'GENERIC/task/task/getOpenSubtaskList'
              }
            }
          }
        }
      }
    }
  )
)()

export { task, TYPES }
